import * as React from 'react';

import PropTypes from 'prop-types';

export class FormattedIntegerStat extends React.Component {
    static propTypes = {
        value: PropTypes.shape({
            value: PropTypes.number.isRequired,
            formatted: PropTypes.string.isRequired,
            suffix: PropTypes.string.isRequired,
            prefix: PropTypes.string.isRequired,
        }).isRequired,
    };

    render() {
        return (
            <div title={this.props.value.value}>
                <span>{this.props.value.prefix}</span>
                <span>{this.props.value.formatted}</span>
                <span>{this.props.value.suffix}</span>
            </div>
        );
    }
}
